module.exports = __webpack_public_path__ + "img/2.22e69f6.png";